import React, {Component} from "react";
import {getCommunicationContacts} from "../../../actions/communications/newCommunicationAction";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {SearchInput} from "Ncontracts.Common.UI";
import ImageCheckbox from "../../common/ImageCheckbox";
import {imageCdnUrls} from "../../common/ImageCdnUrls";
import isNullOrUndefined from "../../../helpers/isNullOrUndefined";
import isEmpty from "../../../helpers/isEmpty";
import {ListContactModel} from "../../../Models/communications/ContactModel";
import _ from "lodash";

class SelectRecipientsFromListForm extends Component {

    static propTypes = {
        allContacts: PropTypes.arrayOf(PropTypes.shape(ListContactModel)),
        fetching: PropTypes.bool,
        getContacts: PropTypes.func,
        onRecipientUpdate: PropTypes.func,
        selectedRecipients: PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.props.getContacts();

        this.state = {
            isContactListInitialized: false,
            isSelectAllChecked: false,
            filteredAndSortedContacts: [],
            searchValue: '',
            sortBy: 'displayName',
            sortDir: 'asc',
        };
    }

    initializeContactList = () => {
        if (this.props.fetching === false) {
            this.setState({
                ...this.state,
                filteredAndSortedContacts: this.props.allContacts,
                isContactListInitialized: true
            });
        }
    };

    getRecipientListItems = () => {
        const listItems = this.state.filteredAndSortedContacts.map(contact => {
            const checkbox = this.isContactSelected(contact) ? <ImageCheckbox isSelected/> : undefined;
            return (
                <div className="list-row columns is-mobile" key={contact.id}
                     onClick={() => this.toggleContactSelection(contact.id)}>
                    <div className="checkbox-cell column is-narrow">
                        {checkbox}
                    </div>
                    <div className="name-cell column">
                        {contact.displayName}
                    </div>
                    <div className="location-cell column">
                        {contact.location}
                    </div>
                    <div className="type-cell column">
                        {contact.type}
                    </div>
                    <div className="organization-cell column">
                        {contact.organization}
                    </div>
                </div>
            );
        });

        return listItems;
    };

    updateFilteredAndSortedContacts = () => {
        const {searchValue, sortBy, sortDir} = this.state;

        const filteredList = this.props.allContacts.filter(contact =>
            isEmpty(searchValue) ||
            contact.displayName.toLowerCase().includes(searchValue.toLowerCase()) ||
            (!isEmpty(contact.location) && contact.location.toLowerCase().includes(searchValue.toLowerCase())) ||
            (!isEmpty(contact.organization) && contact.organization.toLowerCase().includes(searchValue.toLowerCase())) ||
            (!isEmpty(contact.type) && contact.type.toLowerCase().includes(searchValue.toLowerCase()))
        );

        const sortedList = _.orderBy(filteredList, sortBy, sortDir);

        this.setState({ ...this.state, filteredAndSortedContacts: sortedList }, () => {
            this.updateSelectAllCheckboxStatus(this.props.selectedRecipients);
        });
    };

    isContactSelected = contact => {
        return isEmpty(this.props.selectedRecipients.find(c => c.id === contact.id)) ? false : true;
    };

    updateSelectAllCheckboxStatus = selectedRecipients => {
        const selectedRecipientIds = selectedRecipients.map(c => c.id);
        const visibleContactIds = this.state.filteredAndSortedContacts.map(c => c.id);
        const allVisibleContactsAreSelected = !isEmpty(visibleContactIds) && visibleContactIds.every(id => selectedRecipientIds.includes(id));

        this.setState({ ...this.state, isSelectAllChecked: allVisibleContactsAreSelected });
    };

    getSortIcon = columnName => {
        if (this.state.sortBy !== columnName) return undefined;

        return <img className="sort-icon"
                    src={imageCdnUrls[`caret_${this.state.sortDir === 'asc' ? 'up' : 'down'}_grey`]}
                    width="12"
                    height="6"/>;
    };

    updateSort = columnName => {
        this.setState({
            ...this.state,
            sortBy: columnName,
            sortDir: this.state.sortBy === columnName && this.state.sortDir === 'asc' ? 'desc' : 'asc'
        }, () => {
            this.updateFilteredAndSortedContacts();
        });
    };

    toggleContactSelection = contactId => {
        let updatedRecipients = this.props.selectedRecipients.slice();
        const existingSelection = updatedRecipients.find(contact => contact.id === contactId);

        if (isNullOrUndefined(existingSelection)) {
            updatedRecipients.push(this.props.allContacts.find(contact => contact.id === contactId));
            this.updateSelectAllCheckboxStatus(updatedRecipients);
        } else {
            updatedRecipients = updatedRecipients.filter(contact => contact.id !== contactId);

            if (this.state.isSelectAllChecked) {
                this.setState({...this.state, isSelectAllChecked: false});
            }
        }

        this.props.onRecipientUpdate(updatedRecipients);
    };

    toggleSelectAllCheckbox = () => {
        let updatedRecipients = this.props.selectedRecipients.slice();

        const isChecked = !this.state.isSelectAllChecked;
        if (isChecked) {
            updatedRecipients.push(...this.state.filteredAndSortedContacts);
            updatedRecipients = [...new Set(updatedRecipients)]; // removes duplicates
        } else {
            const idsToRemove = this.state.filteredAndSortedContacts.map(contact => contact.id);
            updatedRecipients = updatedRecipients.filter(contact => !idsToRemove.includes(contact.id));
        }

        this.props.onRecipientUpdate(updatedRecipients);

        this.setState({ ...this.state, isSelectAllChecked: isChecked });
    };

    handleSearchValueChange = newValue => {
        this.setState({ ...this.state, searchValue: newValue }, () => {
            this.updateFilteredAndSortedContacts();
        });
    };

    render() {
        const {isContactListInitialized, isSelectAllChecked} = this.state;

        if (!isContactListInitialized) {
            this.initializeContactList();
            return null;
        }

        const recipientListItems = this.getRecipientListItems();

        return (
            <div className="recipient-list-container">
                <div className="search-container">
                    <SearchInput
                        alwaysOpen
                        tooltipText="Search"
                        onValueChange={newValue => this.handleSearchValueChange(newValue)}
                        placeholder="Search by name, location, or type" delay={500}/>
                </div>
                <div className="separator"/>
                <div className="recipient-list">
                    <div className="recipient-selection-list">
                        <div className="list-header columns is-mobile">
                            <div className="checkbox-header column is-narrow">
                                <ImageCheckbox isSelected={isSelectAllChecked}
                                               onClick={() => this.toggleSelectAllCheckbox()}/>
                            </div>
                            <div className="name-header column">
                                <span className="column-header" onClick={() => this.updateSort('displayName')}>
                                    Name {this.getSortIcon('displayName')}
                                </span>
                            </div>
                            <div className="location-header column">
                                <span className="column-header" onClick={() => this.updateSort('location')}>
                                    Location {this.getSortIcon('location')}
                                </span>
                            </div>
                            <div className="type-header column">
                                <span className="column-header" onClick={() => this.updateSort('type')}>
                                    Type {this.getSortIcon('type')}
                                </span>
                            </div>
                            <div className="organization-header column">
                                <span className="column-header" onClick={() => this.updateSort('organization')}>
                                    Organization {this.getSortIcon('organization')}
                                </span>
                            </div>
                        </div>
                        <div className="list-body">
                            {recipientListItems}
                        </div>
                    </div>
                </div>
            </div>);
    }
}

const mapStateToProps = state => ({
    allContacts: state.newCommunication.availableContacts,
    fetching: state.newCommunication.fetching
});

const mapDispatchToProps = dispatch => ({
    getContacts: () => dispatch(getCommunicationContacts())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelectRecipientsFromListForm));
